export default __webpack_public_path__ + "media/images/spinningwheel/sw-button-done-75e1aeb9ebc087a29815d46888edb7c0.png";